@use "../../styles/variables" as *;
@use "../../styles/mixins" as *;

/* Colors
------------------------------------ */
$cookie-overlay-background-color: $white;
$cookie-overlay-border-color: $grey-text-light;
$text-color: $grey;
$button-background-color: $grey;
$button-text-color: $white;

* {
  font-family: Roboto, sans-serif;
  box-sizing: border-box;
}

.overlay-background {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: inherit;

  &.has-placeholder {
    padding: 1.5rem;
  }

  & img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: .2;
    object-fit: cover;
    border-radius: inherit;
  }

  .cookie-overlay {
    z-index: 1;
    background: $cookie-overlay-background-color;
    border: 1.5px solid $cookie-overlay-border-color;
    padding: 1.5rem 1.5rem 0;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    text-align: center;
    border-radius: inherit;

    & .overlay-controls {
      margin: 0.5rem 0 1.5rem;

      button {
        border-radius: 48px;
        line-height: 1rem;
      }
    }

    @include tablet {
      display: flex;
      align-items: center;
      padding: 2.25rem 1.5rem 0 1.5rem;
      margin: 2rem auto;
      width: 100%;
      height: auto;
      max-width: 640px;

      & .overlay-controls {
        display: flex;
        justify-content: center;
        margin: 0 0 2.25rem;

        button {
          line-height: 1rem;
        }
      }
    }

    @include tablet-only {
      margin: 1.25rem;
    }

    @include fullhd {
      & .overlay-controls {
        margin: 1.5rem 0 2.25rem;
      }
    }

    @include desktop-only {
      margin: 1.25rem;
    }

    p,
    h3 {
      color: $text-color;
      line-height: 1.25rem;

      @include tablet {
        line-height: 1.5rem;
      }
    }

    h3 {
      margin: 0;
      font-size: 1rem;

      @include tablet {
        font-size: 1.25rem;
      }
    }

    p {
      font-size: .75rem;
      font-weight: 400;
      margin: 1rem 0;

      @include tablet {
        font-size: 1rem;
        max-width: 35rem;
        margin: 1rem 0;
      }

      a {
        color: $text-color;
      }
    }

    button {
      border: none;
      background: $button-background-color;
      color: $button-text-color;
      padding: .8rem .5rem;
      text-transform: uppercase;
      font-size: .75rem;
      line-height: 0.875rem;
      letter-spacing: .6px;
      font-weight: 300;
      width: 100%;
      cursor: pointer;

      &:not(:last-of-type) {
        margin-bottom: .875rem;

        @include tablet {
          margin-bottom: 0;
          margin-right: 2.5rem;
        }
      }

      @include tablet {
        width: auto;
        padding: .8rem 1.5rem;
      }
    }
  }
}
